<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="
        $browserDetect && $browserDetect.isFirefox ? true : false
      "
      :preview-modal="false"
      :filename="
        'Company Report - ' +
          (this.$route.path.includes('sample')
            ? 'sample'
            : this.$route.params.id)
      "
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="1150px"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @beforeDownload="beforeDownload($event)"
      @hasDownloaded="afterDownload($event)"
      @hasGenerated="afterDownload($event)"
      ref="html2Pdf"
    >
      <section slot="pdf-content" class="pdf_docs prfl-pdf">
        <section ref="page1" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page1" class="banner page reprt-bnr">
            <div class="section_body">
              <img src="/img/pdf_logo.png" alt class="company_logo" />
              <h1>Company Report</h1>
              <h6>
                [{{ parseFloat(this.headerData.bznaics) }}]
                {{ this.headerData.industry }}
              </h6>
              <ul>
                <li>
                  Market Area:
                  <span>{{ this.headerData.area }}</span>
                </li>
                <li>
                  Sales Class:
                  <span>{{ this.headerData.sales_class }}</span>
                </li>
              </ul>
              <div class="bottom_area">
                <div v-if="this.headerData.client_name" class="left">
                  <h4>Client Name</h4>
                  <div class="logo_wpr">
                    <h3>{{ this.user.client_name }}</h3>
                  </div>
                </div>
                <div v-if="this.headerData.developer_name" class="right">
                  <h5>Developed By</h5>
                  <h3>{{ this.user.developer_name }}</h3>
                </div>
              </div>
            </div>
            <div class="banner_footer">
              <!-- <h6>American Author</h6>-->
              <span class="author">
                <!--Joyce Meyer-->
              </span>
              <span class="date">{{
                moment(new Date()).format("MMM Do YYYY")
              }}</span>
            </div>
          </div>
        </section>

        <section ref="page2" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page2" class="company_info page abut-list bg-grey">
            <div class="section_body">
              <ul>
                <li>
                  <p>About the Data</p>
                  <p>
                    US Economic Census Credit Reporting Agencies American
                    Community Survey IRS Statistics of Income Business
                    Directories
                  </p>
                </li>
                <li>
                  <h5>Swot Summary</h5>
                  <p>
                    SWOT Overall Score
                    <br />Business Value Insights <br />Annual Firm Sales
                    <br />Sales-Profitability-Market Opportunity <br />Operating
                    Indicators
                  </p>
                </li>
                <li>
                  <h5>Swot Analysis</h5>
                  <p>
                    Profitability
                    <br />Sales <br />Efficiency <br />Market Opportunity and
                    Saturation <br />Cash Flow <br />Debt Risk
                  </p>
                </li>
                <li>
                  <h5>Insights</h5>
                  <p>
                    Benchmarks
                    <br />Industry Standard Benchmarks <br />Curabitur Eleifend
                    <br />Vivamus Hendrerit <br />Gravida Pharetra
                  </p>
                </li>
                <li>
                  <h5>Covid-19 Impact</h5>
                  <p>Month-to-month-employment-sales Monthly Change Index</p>
                </li>
                <li>
                  <h5>Terms</h5>
                  <p>
                    Industry Financial Insight Terms Market Analysis Insight
                    Terms
                  </p>
                </li>
                <li>
                  <h5>Scoring Explained</h5>
                  <p>Approach to Scored SWOT Metrics Scoring Calculations</p>
                </li>
              </ul>
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>

        <section ref="page3" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page3" class="page about_info">
            <div class="section_body">
              <div class="section_title">
                <h2>About the Data</h2>
                <span class="date">{{
                  moment(new Date()).format("MMM Do YYYY")
                }}</span>
              </div>
              <div class="negetive_margin">
                <div class="md-layout mt-4 mb-4">
                  <div class="md-layout-item md-size-40">
                    <div class="blue-box">
                      <span>Bizminer</span> data is widely accepted for industry
                      analytical work, benchmarking, valuations, forensics and
                      litigation. Bizminer content is accepted in US Tax Court
                      (Bauer vs. IRS: T.C. Memo. 2012-156) and is utilized by
                      state, provincial and national taxing agencies in the US
                      and Canada.
                    </div>
                  </div>
                  <div class="md-layout-item md-size-60 info-text">
                    <p>
                      Raw data analyzed for Bizminer reports is sourced from an
                      array of the nation's government and private statistical
                      sources. None of these raw data sources creates the final
                      measures reflected in Bizminer industry profiles. In
                      total, Bizminer accesses over a billion sourced data
                      points from 15 million business operations for each of its
                      twice annual updates covering a 3-5 year time series.
                      Historical data and Bizminer algorithms are used to inform
                      and test projections for non-reporting firms. Data
                      elements are sourced specifically from:
                    </p>

                    <p>
                      While 100% firm coverage is desirable for analysis
                      purposes, the greatest value of Bizminer reports rests in
                      discerning patterns of activity, which are reflected in
                      the large samples used to develop our reports. The overall
                      current coverage of the databases surpasses 13 million
                      active business operations at any point in time. As is the
                      case with any databases this large, some errors are
                      inevitable. Some firms are missed and specific information
                      on others is lacking from the database. Not all
                      information received is uniform or complete, resulting in
                      the need to develop projection algorithms for specific
                      industry segments and metrics in some report series. No
                      representation is made as to the accuracy of the databases
                      utilized or the results of subsequent analyses.
                    </p>
                  </div>
                </div>
              </div>
              <div class="list_box blue-tick">
                <ul>
                  <li>IRS SOI Corporation Tax Book</li>
                  <li>IRS Statistics of Income</li>
                  <li>US Economic Census</li>
                  <li>US Census Quarterly Financial Reports</li>
                  <li>US Census County Business Patterns</li>
                  <li>Bureau of Labor Statistics Monthly Employment Reports</li>
                  <li>
                    Bureau of Labor Statistics Monthly Unemployment Reports
                  </li>
                  <li>Bureau of Labor Statistics Annual Wage Survey</li>
                  <li>Bureau of Labor Statistics Industry Productivity</li>
                  <li>Reports</li>
                  <li>Bureau of Labor Statistics Price Indices</li>
                  <li>National Agricultural Statistical Service</li>
                  <li>US Census Quarterly Financial Reports</li>
                  <li>US Census Retail Trade Report</li>
                  <li>Data Axle</li>
                  <li>Business Valuation Resources (BVR)</li>
                  <li>Credit Reporting Agencies</li>
                  <li>Business Directories</li>
                  <li>American Community Survey</li>
                </ul>
              </div>
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>

        <section ref="page4" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page4" class="page overall_score">
            <div class="section_body">
              <div class="section_title">
                <h2>SWOT Overall Score</h2>
                <span class="date">{{
                  moment(new Date()).format("MMM Do YYYY")
                }}</span>
              </div>
              <div class="md-layout pt-4 mt-4">
                <div class="md-layout-item md-size-40">
                  <div class="score_circle">
                    <div class="inner_circle">
                      <h2>
                        SWOT
                        <br />Overall Score
                      </h2>
                      <div class="score" v-if="companyReport.average_score">
                        {{ companyReport.average_score }}/5
                      </div>
                      <div class="score" v-if="!companyReport.average_score">
                        N/A
                      </div>
                    </div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      width="300px"
                      height="300px"
                    >
                      <defs>
                        <linearGradient id="GradientColor">
                          <stop offset="10%" stop-color="#00BEF9" />
                          <stop offset="100%" stop-color="#6A28EA" />
                        </linearGradient>
                      </defs>
                      <circle
                        cx="150"
                        cy="150"
                        r="135"
                        stroke-linecap="round"
                        fill="none"
                        stroke-width="30px"
                        stroke="url(#GradientColor)"
                        :stroke-dasharray="companyReport.average_score * 168.5"
                      />
                    </svg>
                  </div>
                </div>
                <div class="md-layout-item md-size-60">
                  <h3>Business Value Insights</h3>
                  <h5>
                    Asset Sales Value:
                    <span>Earnings Approach</span>
                  </h5>
                  <div class="price">{{ companyReport.customVestimate }}</div>
                  <p>
                    Bizminer Valuations Value basis derived from projected
                    company sales; peer group average earnings %; and industry
                    valuation multiples
                  </p>
                </div>
              </div>
              <div class="md-layout pt-4 mt-4 mb-4 annual_bottom">
                <div class="md-layout-item md-size-50">
                  <h4>Annual Firm Sales</h4>
                  <ul>
                    <li>
                      Firm Sales:
                      <span>{{ companyReport.annual_sales }}</span>
                    </li>
                    <li>
                      Firm Sales Rank:
                      <span>{{ companyReport.business_sales_rank }}</span>
                    </li>
                  </ul>
                </div>
                <div class="md-layout-item md-size-50 brdr-lft">
                  <h4>SWOT Scores</h4>
                  <ul>
                    <li>Sales-Profitability-Market Opportunity</li>
                    <li>Operating Indicators</li>
                  </ul>
                </div>
              </div>
            </div>
            <p class="common_footer pt-4">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>

        <section ref="page5" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page5" class="industry_financials_sec">
            <div class="table_sec">
              <div
                class="md-layout-item md-size-100 page"
                v-for="(categoryAux, index) in this.categories"
                :key="index + categoryAux[0]"
              >
                <div class="section_body">
                  <div class="section_title" v-if="index == 0">
                    <h2>SWOT Analysis</h2>
                    <span class="date">{{
                      moment(new Date()).format("MMM Do YYYY")
                    }}</span>
                  </div>
                  <div
                    :key="ind + category"
                    v-for="(category, ind) in categoryAux"
                    class="tble-box"
                  >
                    <div class="tbl-title">
                      <h4>{{ category }}</h4>
                    </div>
                    <div class="inner-tbl">
                      <div
                        class="list-tick"
                        v-for="item in getDataByCategory(category)"
                        :key="item.title"
                      >
                        <img src="/img/tick-blue.png" alt />
                        <h4>{{ item.title }}:</h4>
                        <p>{{ item.text }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <p class="common_footer pt-4">
                  Copyright © 2022 Bizminer. All Rights Reserved.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section ref="page6" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page6" class="page insight_sec competitor_sec">
            <div class="md-layout-item md-size-100">
              <div class="section_body">
                <div class="section_title">
                  <h2>Insights</h2>
                  <span class="date">{{
                    moment(new Date()).format("MMM Do YYYY")
                  }}</span>
                </div>

                <div class="tble-box">
                  <div class="tbl-title">
                    <h4>Industry Financial Insights {{ ifPeriod }}</h4>
                    <!--      <p>Financial Metrics: Sales Class: {{ salesClass }} (Peer industry and sales class average % basis)</p>-->
                  </div>
                  <div class="inner-tbl" v-if="spend">
                    <md-table
                      v-model="spend"
                      table-header-color="blue"
                      class="dark_blue"
                      style="flex: 1;"
                    >
                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="Benchmarks">{{
                          item.name
                        }}</md-table-cell>
                        <md-table-cell md-label="Industry">{{
                          item.percentage
                        }}</md-table-cell>
                        <md-table-cell md-label="Firm">{{
                          item.firm
                        }}</md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>

                  <div class="inner-tbl" v-if="benchmarks">
                    <md-table
                      v-model="benchmarks"
                      table-header-color="blue"
                      class="dark_blue"
                      style="flex: 1;"
                    >
                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="Industry Standard Benchmarks"
                          >{{ item.name }}
                        </md-table-cell>
                        <md-table-cell md-label="Industry">{{
                          item.ratio
                        }}</md-table-cell>
                        <md-table-cell md-label="Firm">{{
                          item.firm
                        }}</md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </div>
        </section>

        <section ref="page7" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page7" class="page insight_sec competitor_sec">
            <div class="section_body">
              <div class="tble-box">
                <div class="tbl-title">
                  <h4>Industry Market Insights {{ mrPeriod }}</h4>
                  <!-- <p>Total Industry Sales ({{ area }})</p>-->
                </div>
                <div class="inner-tbl" v-if="main">
                  <md-table
                    v-model="main"
                    table-header-color="blue"
                    class="dark_blue"
                    style="flex: 1;"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell md-label="Main">{{
                        item.name
                      }}</md-table-cell>
                      <md-table-cell md-label="Value">{{
                        item.value
                      }}</md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>

                <div class="inner-tbl" v-if="penetration">
                  <md-table
                    v-model="penetration"
                    table-header-color="blue"
                    class="dark_blue"
                    style="flex: 1;"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell md-label="Penetration">{{
                        item.name
                      }}</md-table-cell>
                      <md-table-cell md-label="Value">{{
                        item.value
                      }}</md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>

                <div class="inner-tbl" v-if="income">
                  <md-table
                    v-model="income"
                    table-header-color="blue"
                    class="dark_blue"
                    style="flex: 1;"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell md-label="Demographics">{{
                        item.name
                      }}</md-table-cell>
                      <md-table-cell md-label="Value">{{
                        item.value
                      }}</md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>
              </div>
            </div>

            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>

        <section ref="page8" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page8" class="page covid-sec pt-4">
            <div class="section_body">
              <div class="section_title">
                <h2>Covid-19 Impact</h2>
                <span class="date">{{
                  moment(new Date()).format("MMM Do YYYY")
                }}</span>
              </div>

              <div class="tble-box">
                <div class="inner-tbl" v-if="covid">
                  <md-table
                    v-model="covid"
                    table-header-color="blue"
                    class="dark_blue"
                    style="flex: 1;"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell md-label="MONTH-TO-MONTH-EMPLOYMENT-SALES">
                        <div class="md-table-side-label">
                          {{ item.title }}
                        </div>
                      </md-table-cell>
                      <md-table-cell
                        v-for="(key, index) in item.dates"
                        :key="key"
                        :md-label="covidColumns[index]"
                      >
                        {{ key }}
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>

                <div class="inner-tbl" v-if="covidChange">
                  <md-table
                    v-model="covidChange"
                    table-header-color="blue"
                    class="dark_blue"
                    style="flex: 1;"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell
                        :md-label="'Percentage change from ' + covidColumns[0]"
                      >
                        <div class="md-table-side-label">
                          {{ item.title }}
                        </div>
                      </md-table-cell>
                      <md-table-cell
                        v-for="(key, index) in item.dates"
                        :key="key"
                        :md-label="covidChangeColumns[index]"
                        >{{ key }}
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>
              </div>
              <div class="section_title" v-if="covidChangeColumns">
                <h2>Monthly Change Index ({{ covidChangeColumns[0] }}=1.00)</h2>
              </div>
              <div class="tble-box">
                <div class="inner-tbl">
                  <div v-if="chartInfo" class="chartcls" style="width: 100%;">
                    <LineChart
                      :categories="labelsdata"
                      :chartdata="seriesFilter"
                    />
                  </div>
                </div>
              </div>
            </div>

            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>

        <section ref="page9" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page9" class="page covid-sec pt-4">
            <div class="table_sec">
              <div class="section_body">
                <div class="table-box">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-50">
                      <div class="blu-box">
                        <span>Bizminer reports</span> now adjust our raw data to
                        better reflect the most recent changes in local and
                        national industry markets.
                      </div>
                      <h4>
                        We accomplish this by integrating additional Census
                        Bureau data with our proprietary content, allowing us to
                        accelerate and refine month-to-month trends. Our content
                        displays the new data in three ways:
                      </h4>
                    </div>
                    <div class="md-layout-item md-size-50">
                      <div class="tick-sec">
                        <img src="/img/tick-blue.png" alt />
                        Our employment data is adjusted to better reflect the
                        most recent realities at local and national levels
                      </div>
                      <div class="tick-sec">
                        <img src="/img/tick-blue.png" alt />
                        Updates of industry market sales averages and total
                        market volume are accelerated by one month and renamed
                        as Trailing Twelve Month (TTM) values
                      </div>
                      <div class="tick-sec">
                        <img src="/img/tick-blue.png" alt />
                        Updates of industry market sales averages and total
                        market volume are accelerated by one month and renamed
                        as Trailing Twelve Month (TTM) values
                      </div>
                    </div>
                  </div>
                  <p>
                    Updates of industry market sales averages and total market
                    volume are accelerated by one month and renamed as Trailing
                    Twelve Month (TTM) values New content will display monthly
                    (not annual) industry sales and employment from year-end
                    2019 through both Preliminary Update and Advance Projection
                    months. These enhanced protocols will be most obvious in our
                    Industry Market Trend series, including a new “Monthly
                    Change” tab in each report. Similarly, snapshot reports like
                    the SWOTXPRESS, Competitive Market Narrative and Company
                    Insight series will reflect our new update protocols and add
                    content for Preliminary Update and Advance months. Shorter
                    projections are more detailed and accurate than longer-term
                    projections. Preliminary Update data is calculated on a more
                    accurate and detailed basis than the Advance Projection
                    month, which will adjust as it moves to “update month”
                    status the following month. Interpret and utilize this
                    content accordingly.
                  </p>
                </div>
              </div>

              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </div>
        </section>

        <section ref="page10" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page10" class="page terms">
            <div class="section_body">
              <div class="section_title">
                <h2>Terms</h2>
              </div>
              <div class="md-layout mt-4 mb-4">
                <div class="md-layout-item md-size-100 terms_header">
                  Industry Financial Insight Terms
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>
                    Industry peer group percentage averages are applied to the
                    company's estimatedrevenue.
                  </h6>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Gross Margin:</h6>
                  <p>Business Revenue minus Cost of Sales</p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Officer/Owner's Compensation:</h6>
                  <p>
                    Total wage compensation for services of company officers
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Depreciation:</h6>
                  <p>
                    Current portion of non-cash
                    depreciation-amortization-depletion
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Operating Expenses:</h6>
                  <p>
                    Discretionary Expenses (excludes Cost of Sales and Interest
                    Paid)
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>After-Tax Net Profit:</h6>
                  <p>Net Profit after payment of income taxes</p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Owner Earnings:</h6>
                  <p>Officers Compensation+Net Profit+Depreciation</p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Net Worth/Assets:</h6>
                  <p>Net Worth as a percent of Total Assets</p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Accounts Receivable: Total Assets:</h6>
                  <p>Short-term receivables as a percent of Total Assets</p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Accounts Payable:TL& NW:</h6>
                  <p>
                    Short-term receivables as a percent of Total Liabilities+Net
                    Worth
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Days Payable:</h6>
                  <p>365/(Cost of Sales/Accounts Payable ratio)</p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Days Receivable:</h6>
                  <p>365/(Business Revenue/Receivables)</p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Current Ratio:</h6>
                  <p>Current Assets/Current Liabilities</p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Interest Coverage:</h6>
                  <p>
                    [Earnings before Interest, Taxes Due,
                    DepreciationAmortization]/Interest expense
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Current Liabilities:</h6>
                  <p>Net Worth: Current Liabilities/Net Worth</p>
                </div>
              </div>
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>

        <section ref="page11" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page11" class="page terms">
            <div class="section_body">
              <div class="md-layout mt-4 mb-4">
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Total Liabilities: Net Worth:</h6>
                  <p>Total liabilities/Net Worth</p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Modified Z-Score:</h6>
                  <p>
                    A modified form of the Altman Z-Score which evaluates
                    default risk
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Net Working Capital: Revenue:</h6>
                  <p>(Current Assets-Current Liabilities)/Business Revenue</p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Accounts Payable:Revenue:</h6>
                  <p>Accounts Payable/Business Revenue</p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Loans-Notes Payable:Net Worth:</h6>
                  <p>Loans-Notes Payable/Net Worth</p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Owner Earnings (Cash Flow) Approach:</h6>
                  <p>Revenue/Owner Earnings market valuation approach</p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>
                    Bizminer Valuations Value basis derived from projected
                    company sales; peer group average earnings %; and industry
                    valuation multiples. Median ranges reflect a range of market
                    conditions and business performance at this revenue scale.
                  </h6>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>
                    You should not use Bizminer Valuations in place of a
                    professional valuation or as the basis of any specific
                    business-related or other financial transaction; nor to
                    secure a business or personal loan.
                  </h6>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Sales Approach:</h6>
                  <p>Revenue/Annual Sales market value approach</p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Median and Quartiles: Median:</h6>
                  <p>the point at which 50% of a sample is above and 50% of</p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>the same below the value.</h6>
                  <p>between the median and the highest value</p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>
                    Quartile 1 lies at the mid-point between the median and the
                    lowest value; Quartile 3
                  </h6>
                </div>
              </div>
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>

        <section ref="page12" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page12" class="page terms">
            <div class="section_body">
              <div class="md-layout mt-4 mb-4">
                <div class="md-layout-item md-size-100 terms_header">
                  Market Analysis Insight Terms
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Market Area:</h6>
                  <p>
                    The selected market parameters for this industry. Where
                    there are at least five identified industry establishments,
                    default market parameters are:
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Industry Map:</h6>
                  <p>
                    Displays the closest operations in the same industry as the
                    selected firm
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Competitors:</h6>
                  <p>
                    The number of same-industry operations within the market
                    area.
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>15 mile radius</h6>
                  <p>
                    44-45 Retail Trade
                    <br />72 Accommodation-Food Services <br />811-812 Other
                    Services
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Metro</h6>
                  <p>
                    23 Construction
                    <br />42 Wholesale Trade <br />48-49
                    Transportation-Warehousing <br />51 Information <br />52
                    Finance and Insurance <br />53 Real Estate- Rental and
                    Leasing <br />54 Professional-Scientific-Technical Services
                    <br />56 Administrative-Support-Waste-Remediation <br />61
                    Educational Services <br />62 Health Care-Social Assistance
                    <br />71 Arts-Entertainment- Recreation <br />813
                    Religious-Grantmaking-Civic-Professional and Similar
                    Organizations
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Us-national</h6>
                  <p>
                    11 Agriculture-Forestry-Fishing-Hunting
                    <br />21 Mining-Quarrying- Oil & Gas Extraction <br />22
                    Utilities <br />31-32-33 Manufacturing <br />55 Management-
                    Companies & Enterprises
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Industry Market Sales Volume:</h6>
                  <p>Aggregate industry market sales</p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Average Site Sales:</h6>
                  <p>
                    Average annual revenue of industry market operations in the
                    market area.
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Average Small Business Sales:</h6>
                  <p>
                    Average annual sales of single site firms with 25employees
                    in the market
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Firm Sales Rank:</h6>
                  <p>
                    Sales rank based on this location's estimated revenue among
                    all sameindustry market operations
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>US and Market Sales per Household:</h6>
                  <p>
                    Sales per household using the US as a comparisonbasis for
                    the local market or, if a national market, displaying that
                    value.
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Per Capita Income:</h6>
                  <p>Average area income per person</p>
                  <h6>Median Household Income:</h6>
                  <p>Median (mid-point) area income per household</p>
                </div>
              </div>
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>

        <section ref="page13" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page13" class="page swot_express purple-bg">
            <div class="section_body">
              <div class="section_title">
                <h2>
                  SWOT-XPRESS
                  <span>Scoring Explained</span>
                </h2>
              </div>
              <div class="subtext">
                In most cases, the variance for each metric measures the
                percentage difference between input firm ratios and the industry
                average. The Sales per Household Market Opportunity Index and
                Location Quotient compare local and national market data to
                determine the variance between the two. Each variance results in
                a Score of 1-5 (5 being best) for each year of each selected
                ratio. The application of the Variances to the Score depends on
                the specific metric; in most cases higher is better (Standard
                Scoring); in some, lower (Reverse Scoring) is better; in a few,
                closest to the industry average (Balanced Scoring) is best.
              </div>
              <div class="data_table">
                <div class="table_head">Approach to Scored SWOT Metrics:</div>
                <table class="table_data">
                  <tr>
                    <td>Owner Earnings (%)-Standard</td>
                    <td>Days Receivable-Reverse</td>
                  </tr>
                  <tr>
                    <td>Sales Rank -Standard</td>
                    <td>Current Ratio-Standard</td>
                  </tr>
                  <tr>
                    <td>Variance from Average Sales-Standard</td>
                    <td>Current tdabitdties:Net Worth-Reverse</td>
                  </tr>
                  <tr>
                    <td>Variance from Small Business Sales-Standard</td>
                    <td>Long Term tdabitdties: Net Worth-Reverse</td>
                  </tr>
                  <tr>
                    <td>
                      Sales per Household Market OpportunityIndex-Standard
                    </td>
                    <td>Total tdabitdties:Net Worth-Reverse</td>
                  </tr>
                  <tr>
                    <td>Location Quotient-Reverse</td>
                    <td>Days Payable-Balanced</td>
                  </tr>
                  <tr>
                    <td>Sales per Employee Index-Standard</td>
                    <td>Modified Z-Score-Standard</td>
                  </tr>
                  <tr>
                    <td>Efficiency Index-Standard</td>
                    <td></td>
                  </tr>
                </table>
              </div>
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>

        <section ref="page14" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page14" class="page swot_express purple-bg">
            <div class="section_body">
              <div class="score_calculation">
                <h3>Scoring Calculations:</h3>
                <ul class="card">
                  <li>
                    <div class="card_wpr">
                      <h4>
                        Standard
                        <span>(basically higher is better)</span>
                      </h4>
                      <ul>
                        <li>+/-10% from average= 3</li>
                        <li>+11% to +20% above average= 4</li>
                        <li>>20% above average= 5</li>
                        <li>+11% to +20% below average= 2</li>
                        <li>>20% below average= 1</li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div class="card_wpr">
                      <h4>
                        Reverse
                        <span>(lower is better)</span>
                      </h4>
                      <ul>
                        <li>+/-10% from average= 3</li>
                        <li>+11% to +20% above average= 2</li>
                        <li>>20% above average= 1</li>
                        <li>+11% to +20% below average= 4</li>
                        <li>>20% below average= 5</li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div class="card_wpr">
                      <h4>
                        Balanced
                        <span
                          >(middle is good, too high or too low is not)</span
                        >
                      </h4>
                      <ul>
                        <li>+/-10% from average= 5</li>
                        <li>+11% to +20% above average= 4</li>
                        <li>>20% above average= 3</li>
                        <li>+11% to +20% below average= 2</li>
                        <li>>20% below average= 1</li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import { ChartCard } from "@/components";
import VueHtml2pdf from "vue-html2pdf";
import moment from "moment";
import LineChart from "@/components/LineChart.vue";

export default {
  name: "PdfContent",
  components: {
    // ChartCard,
    VueHtml2pdf,
    LineChart,
  },
  props: ["headerData"],
  data() {
    return {
      chartKey: 0,
      categories: [],
      covidImpactChangeLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: true,
          },
          showPoint: true,
          height: "700px",
        },
      },

      moment: moment,
      chartInfo: false,
      chartLoaded: false,
      industrySummaryChart: {
        data: {
          labels: [],
          series: [],
        },
      },
      filtered_years: [],
      seriesFilter: [],
      labelsdata: ["0", "Feb-22", "March-22 Advance"],
    };
  },
  mounted() {
    this.chartInfo = true;
    this.init();
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    companyReport() {
      return this.$store.getters["user/companyReport"];
    },
    companyReportSummary() {
      return this.$store.getters.companyReportSummary;
    },
    ifPeriod() {
      return this.companyReport["IF"] ? this.companyReport["IF"]["period"] : "";
    },
    mrPeriod() {
      return this.companyReport["MR"] ? this.companyReport["MR"]["period"] : "";
    },
    area() {
      return this.companyReport["MR"] ? this.companyReport["MR"]["area"] : "";
    },
    salesClass() {
      return this.companyReport["IF"]
        ? this.companyReport["IF"]["sales-class"]
        : "";
    },
    spend() {
      return this.companyReport["IF"]
        ? Object.keys(this.companyReport["IF"]["spend"]).map((key) => {
            return {
              name: key,
              dollar: this.companyReport["IF"]["spend"][key]["dollar"],
              firm: this.companyReport["IF"]["spend"][key]["firm"],
              percentage: this.companyReport["IF"]["spend"][key]["percentage"],
            };
          })
        : null;
    },
    benchmarks() {
      return this.companyReport["IF"]
        ? Object.keys(this.companyReport["IF"]["benchmarks"]).map((key) => {
            return {
              name: key,
              firm: this.companyReport["IF"]["benchmarks"][key]["firm"],
              ratio: this.companyReport["IF"]["benchmarks"][key]["ratio"],
            };
          })
        : null;
    },
    main() {
      return this.companyReport["MR"]
        ? Object.keys(this.companyReport["MR"]["main"]).map((key) => {
            return {
              name: key,
              value: this.companyReport["MR"]["main"][key],
            };
          })
        : null;
    },
    penetration() {
      return this.companyReport["MR"]
        ? Object.keys(this.companyReport["MR"]["penetration"]).map((key) => {
            return {
              name: key,
              value: this.companyReport["MR"]["penetration"][key],
            };
          })
        : null;
    },
    income() {
      return this.companyReport["MR"]
        ? Object.keys(this.companyReport["MR"]["income"]).map((key) => {
            return {
              name: key,
              value: this.companyReport["MR"]["income"][key],
            };
          })
        : null;
    },
    covid() {
      return this.companyReport.covid &&
        typeof this.companyReport.covid != undefined
        ? Object.keys(this.companyReport.covid).map((key) => {
            return {
              title: key,
              dates: this.companyReport.covid[key],
            };
          })
        : null;
    },
    covidColumns() {
      return this.companyReport.covidColumns &&
        typeof this.companyReport.covidColumns != undefined
        ? this.companyReport.covidColumns
        : null;
    },
    covidChange() {
      return this.companyReport.covidChange &&
        typeof this.companyReport.covidChange != undefined
        ? Object.keys(this.companyReport.covidChange).map((key) => {
            return {
              title: key,
              dates: this.companyReport.covidChange[key],
            };
          })
        : null;
    },
    covidChangeColumns() {
      return this.companyReport.covidChangeColumns &&
        typeof this.companyReport.covidChangeColumns != undefined
        ? this.companyReport.covidChangeColumns
        : null;
    },
    pdfDownloadSetting() {
      //alert(this.user.preferences.defaultPDFDownload);
      return this.user &&
        this.user.preferences &&
        this.user.preferences.defaultPDFDownload
        ? this.user.preferences.defaultPDFDownload
        : "_blank";
    },
  },
  methods: {
    reverseArray(a) {
      var rA = [];
      for (var i = a.length; i > 0; i--) {
        rA.push(a[i - 1]);
      }

      return rA;
    },
    getDataByCategory(category) {
      if (this.companyReport.dynamic_text) {
        let titleTextList = [];
        Object.values(this.companyReport.dynamic_text).map((array) => {
          array.map((object) =>
            object.category === category ? titleTextList.push(object) : ""
          );
        });
        return titleTextList;
      }
      return "";
    },

    getCategories() {
      if (this.companyReportSummary && this.companyReport.dynamic_text) {
        let categories = [];
        Object.values(this.companyReport.dynamic_text).map((array) => {
          array.map((object) =>
            categories.includes(object.category)
              ? ""
              : categories.push(object.category)
          );
        });
        return categories;
      } else {
        return [];
      }
    },

    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    onProgress($e) {},
    async beforeDownload({ html2pdf, options, pdfContent }) {
      this.$store.commit("user/SET_PDF_LOADING", true);

      let page1 = this.$refs.page1;
      let page2 = this.$refs.page2;
      let page3 = this.$refs.page3;
      let page4 = this.$refs.page4;
      let page5 = this.$refs.page5;
      let page6 = this.$refs.page6;
      let page7 = this.$refs.page7;
      let page8 = this.$refs.page8;
      let page9 = this.$refs.page9;
      let page10 = this.$refs.page10;
      let page11 = this.$refs.page11;
      let page12 = this.$refs.page12;
      let page13 = this.$refs.page13;
      let page14 = this.$refs.page14;

      let pages = [
        page1,
        page2,
        page3,
        page4,
        page5,
        page6,
        page7,
        page8,
        page9,
        page10,
        page11,
        page12,
        page13,
        page14,
      ];

      var worker = html2pdf()
        .set(options)
        .from(pages[0])
        .toPdf();
      pages.slice(1).forEach(function(page) {
        worker = worker
          .get("pdf")
          .then(function(pdf) {
            pdf.addPage();
          })
          .from(page)
          .toContainer()
          .toCanvas()
          .toPdf();
      });
      worker.get("pdf").then((pdf) => {
        if (this.$store.getters["user/pdfMustBeDownloaded"]) worker.save();
        else window.open(pdf.output("bloburl"), "_blank");
      });
    },
    async afterDownload() {
      this.$store.commit("user/SET_PDF_LOADING", false);
    },
    filterNode(node) {
      if (node instanceof Text) {
        return true;
      }
      return (
        [
          "div",
          "span",
          "p",
          "i",
          "strong",
          "main",
          "aside",
          "article",
          "pre",
          "code",
          "time",
          "address",
          "header",
          "footer",
        ].includes(node.tagName.toLowerCase()) ||
        /^h[123456]$/i.test(node.tagName)
      );
    },
    convertImages() {},

    init() {
      var categoriesAux = this.getCategories();
      var aggregateCategories = [];
      categoriesAux.map((el) => {
        if (aggregateCategories.length < 3) {
          if (aggregateCategories.length == 2) {
            this.categories.push(aggregateCategories);
            aggregateCategories = [];
          }
          aggregateCategories.push(el);
        } else aggregateCategories = [];
      });

      if (aggregateCategories.length === 1) {
        this.categories.push(aggregateCategories);
      }

      this.covidImpactChangeLineChart.data = {
        labels: this.covidChangeColumns,
        series: this.covidChange
          ? this.covidChange.map((item) => ({
              name: item.title,
              data: item.dates.map((el) => {
                if (el) return parseFloat(el.replace("%", ""));
                else return 0;
              }),
            }))
          : "",
      };

      this.chartKey++;

      if (
        this.covidImpactChangeLineChart.data &&
        this.covidImpactChangeLineChart.data.labels
      ) {
        Object.values(this.covidImpactChangeLineChart.data.labels).forEach(
          (item, index) => {
            if (item == "") item = "0";
            this.labelsdata[index] = item;
          }
        );

        Object.values(this.covidImpactChangeLineChart.data.series).forEach(
          (item, index) => {
            if (this.covidImpactChangeLineChart.data.labels[index] != "") {
              var obj = { name: item.name, data: item.data };
              this.seriesFilter.push(obj);
            }
          }
        );
      }
    },
  },

  watch: {
    covidChange(newVal, oldVal) {
      this.chartInfo = true;
      this.init();
    },
  },
};
</script>

<style lang="scss">
.pdf_docs .page {
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 21cm;
  max-height: 21cm;
  overflow: hidden;
}
</style>
